export const env = {
  apiBaseUrl:
    process.env.REACT_APP_API_BASE_URL?.replace(/\/+$/, '') ||
    'http://localhost:4000/api',
  appName: process.env.REACT_APP_APP_NAME ?? 'HnB',
  nodeEnv: process.env.NODE_ENV ?? 'development',
  isDev: process.env.NODE_ENV !== 'production',
};